import RequestModule from "~/common/RequestModule";
import MergeModule from "~/common/MergeModule";
import { _ } from "~/common/Utils";

const prefix = process.env.PUBLIC_URL;
const coreConfigUrl = `${prefix}/libs/config/config.json`;
const customConfigUrl = `${prefix}/custom/config.json`;
const overridesConfigUrl = `${prefix}/overrides/config.json`;

const buildRoutes = (config) => {
    const result = {};

    for (const pageName in config.pages)
        result[pageName] = `${prefix}${config.pages[pageName].route}`;

    return result;
};

const buildConfig = async function (fetchNew = false) {
    const result = {};

    let queryParam = "";
    if (fetchNew === true) {
        queryParam = `?ver=${_.Generate.Guid()}`
    }

    const coreConfig = await RequestModule.fetchJson(`${coreConfigUrl}${queryParam}`);
    const customConfig = await RequestModule.fetchJson(`${customConfigUrl}${queryParam}`);
    const overridesConfig = await RequestModule.fetchJson(`${overridesConfigUrl}${queryParam}`);

    result.defaultSettings = MergeModule.cloneMerge(coreConfig, customConfig);
    result.defaultSettings = MergeModule.cloneMerge(result.defaultSettings, overridesConfig);

    result.routes = buildRoutes(result.defaultSettings);

    return result;
};

const ConfigManager = {
    build: buildConfig
};

export default ConfigManager;